var _circle, _circle2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 30,
    fill: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1341_42297",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 61,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 36C6.5 19.4315 19.9315 6 36.5 6C44.4565 6 52.0871 9.16071 57.7132 14.7868C63.3393 20.4129 66.5 28.0435 66.5 36C66.5 52.5685 53.0685 66 36.5 66C19.9315 66 6.5 52.5685 6.5 36ZM35.69 46.83L49.4 28.83V28.74C50.0538 27.8826 50.2005 26.7415 49.7848 25.7465C49.3692 24.7516 48.4543 24.054 47.3848 23.9165C46.3154 23.7791 45.2538 24.2226 44.6 25.08L33.26 40.08L28.37 33.84C27.7108 32.9933 26.65 32.5625 25.5872 32.71C24.5243 32.8575 23.6209 33.5608 23.2172 34.555C22.8135 35.5492 22.9708 36.6833 23.63 37.53L30.95 46.86C31.5225 47.5845 32.3967 48.005 33.32 48C34.2485 47.9978 35.1236 47.5657 35.69 46.83Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1341_42297)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    fill: "#3AC562"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.b3b34f668d027d0d93fd61dcc7dd10c8.svg";
export { ForwardRef as ReactComponent };